import { deepFreeze } from 'utils/deepFreeze';
import { MealDealState } from '../types';

export const initialState: Readonly<MealDealState> = deepFreeze({});
